module.exports = __webpack_public_path__ + "img/aboutUs-hj.b34e22b6.png";